import api from "./api";

const create = (data) => {
  return api.post("/api/wo-form-template", data);
};

const getAll = (isActive, formType, customerId) => {
  const params = {};
  if (isActive !== undefined && isActive !== "") params.isActive = isActive;
  if (formType !== undefined && formType !== "") params.formType = formType;
  if (customerId !== undefined && customerId !== null && customerId !== "") params.customerId = customerId;
  return api.get("/api/wo-form-template", { params });
};

// Ungated template list for the "start from a template" dropdowns in the WO form
// create flow and the customer:read-gated Location template section, so picking a
// template doesn't require form:templateRead. Same params as getAll.
const getAllForSelection = (isActive, formType, customerId) => {
  const params = {};
  if (isActive !== undefined && isActive !== "") params.isActive = isActive;
  if (formType !== undefined && formType !== "") params.formType = formType;
  if (customerId !== undefined && customerId !== null && customerId !== "") params.customerId = customerId;
  return api.get("/api/wo-form-template/for-selection", { params });
};

const getById = (id) => {
  return api.get(`/api/wo-form-template/${id}`);
};

const update = (id, data) => {
  return api.patch(`/api/wo-form-template/${id}`, data);
};

const archive = (id) => {
  return api.patch(`/api/wo-form-template/${id}/archive`);
};

const restore = (id) => {
  return api.patch(`/api/wo-form-template/${id}/restore`);
};

const remove = (id) => {
  return api.delete(`/api/wo-form-template/${id}`);
};

// Dedicated endpoint so form:templateDuplicate is guarded separately from create.
const duplicate = (id, createdBy) => {
  return api.post(`/api/wo-form-template/${id}/duplicate`, { createdBy });
};

const FormTemplateService = {
  create,
  getAll,
  getAllForSelection,
  getById,
  update,
  archive,
  restore,
  remove,
  duplicate,
};

export default FormTemplateService;
